import { render, staticRenderFns } from "./BlogSection.vue?vue&type=template&id=c4da7236&scoped=true"
import script from "./BlogSection.vue?vue&type=script&setup=true&lang=js"
export * from "./BlogSection.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4da7236",
  null
  
)

export default component.exports